import React from "react";

export default function ContentPage({ title, lastUpdated, lead, sections }) {
  return (
    <div className="min-h-screen bg-brand-cream pt-32 pb-20 px-4">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white rounded-sm shadow-sm border border-gray-100 overflow-hidden">
          <div className="px-6 sm:px-10 py-10 sm:py-12 border-b border-gray-100">
            <span className="section-label">Information</span>
            <h1 className="font-display text-4xl sm:text-5xl text-brand-dark font-light mt-3">{title}</h1>
            <p className="font-body text-sm text-gray-400 mt-4">Last updated: {lastUpdated}</p>
            {lead && <p className="font-body text-sm sm:text-base text-gray-500 leading-relaxed mt-6 max-w-2xl">{lead}</p>}
          </div>

          <div className="px-6 sm:px-10 py-8 sm:py-10 space-y-8">
            {sections.map((section) => (
              <section key={section.heading}>
                <h2 className="font-display text-2xl text-brand-dark mb-3">{section.heading}</h2>
                {section.body && (
                  <p className="font-body text-sm sm:text-base text-gray-500 leading-relaxed mb-4">
                    {section.body}
                  </p>
                )}
                {section.points && (
                  <ul className="space-y-3">
                    {section.points.map((point) => (
                      <li key={point} className="flex items-start gap-3 font-body text-sm sm:text-base text-gray-600 leading-relaxed">
                        <span className="mt-1.5 h-1.5 w-1.5 rounded-full bg-brand-red shrink-0" />
                        <span>{point}</span>
                      </li>
                    ))}
                  </ul>
                )}
              </section>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
